import React, { useState } from 'react';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { notificationService } from '@app/services/notification.service';
import { doLoginAccept } from '@app/store/slices/authSlice';
import { useLoginRedirect } from '@FW/hooks/useLoginRedirect';
import { useAppDispatch } from '@hooks/shared/reduxHooks';
import { Button, Flex, Form, Input } from 'antd';
import Title from 'antd/es/typography/Title';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { AuthWrap } from './AuthWrap.styled';

interface VerificationFormData {
	verification: string;
}

const VerificationForm: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const redirectAfterLogin = useLoginRedirect();

	const submitForm = (values: VerificationFormData) => {
		setLoading(true);
		dispatch(doLoginAccept(values))
			.unwrap()
			.then(() => redirectAfterLogin({ loginMethod: 'password' }))
			.catch((err) => {
				notificationService.error({
					message: err.message ? err.message : t('api.error'),
				});
			})
			.finally(() => setLoading(false));
	};
	return (
		<Flex vertical gap={16} className='w-full'>
			<AuthWrap className='text-green'>
				<Button onClick={() => navigate('/auth/login')}>
					<ArrowLeftOutlined /> {t('passwordRecovery.passwordRecoveryReturn')}
				</Button>

				<Title level={3}>{t('auth.loginFormTitle')}</Title>

				<Form layout='vertical' onFinish={submitForm} size='large'>
					<Flex gap={16} vertical>
						<Form.Item
							name='verification'
							label={t('auth.verificationFormTitle')}
							rules={[
								{
									pattern: /^\d+$/,
									message: t('auth.otpDigitsOnly'),
									validateTrigger: 'onSubmit',
								},
								{ required: true, message: t('auth.verificationFormTitle') },
							]}>
							<Input autoFocus type='text' />
						</Form.Item>
						<Form.Item>
							<Button type='primary' htmlType='submit' loading={loading}>
								{t('auth.buttonText')}
							</Button>
						</Form.Item>
					</Flex>
				</Form>

				<div>
					<Link to='/auth/login'>{t('auth.verificationFormSendOTP')}</Link>
				</div>
			</AuthWrap>
		</Flex>
	);
};

export default VerificationForm;
